import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UserComponent } from './user.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProfileComponent } from './profile/profile.component';
import { ForceResetModalComponent } from './login/forceresetmodal/forceresetmodal.component';
import { ChangePasswordComponent } from './changepassword/changepassword.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    Ng4LoadingSpinnerModule
  ],
  declarations: [UserComponent, LoginComponent, RegisterComponent, ProfileComponent, ForceResetModalComponent, ChangePasswordComponent, ForgotPasswordComponent],
  exports: [UserComponent, LoginComponent, RegisterComponent]
})
export class UserModule { }